import React, {useState} from 'react';
import StepWizard from "react-step-wizard";
import Section from "../../components/Section";

import BusquedaOperacionEcommerce from "./BusquedaOperacionEcommerce";
import DatosFiscales from '../../components/DatosFiscales';
import FinalizacionProceso from "../../components/FinalizacionProceso";

const FacturaEcommerce = () => {
    const [state, updateState] = useState({});

    const setInstance = SW => {
        updateState({
            ...state,
            SW
        })
    };

    return (<Section>
            <StepWizard
                instance={setInstance}
                isLazyMount={true}
            >
                <BusquedaOperacionEcommerce/>
                <DatosFiscales/>
                <FinalizacionProceso/>
            </StepWizard>
        </Section>
    );
};

export default FacturaEcommerce;